import { Button, Col, Form, Input, Row } from "antd";
import instance from "config/_axios";
import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "store/services";
import SunEditor from "suneditor-react";
import { asyncN } from "utils/notifications";
import { referenceModalType, subjectTopicReferenceType } from "./types";

const CaseOrQuestion: FC<referenceModalType> = ({ topicId, userId, data, refresh, setRefresh, closeModal }): JSX.Element => {
    const [form] = Form.useForm();
    const { t } = useTranslation()
    const auth: any = useAppSelector(state => state.auth);

    useEffect(() => {
        if (data) {
            form.setFieldsValue({
                ...data
            })
        }
    }, [data])

    const onFinish = async (values: any) => {
        try {
            let dataReq = new FormData();
            dataReq.append("name", values?.name);
            dataReq.append("subject_topic_id", `${topicId}`);
            if (!auth?.user?.role?.includes("teacher")) {
                dataReq.append("user_id", `${userId}`);
            }
            dataReq.append("type", `5`);
            dataReq.append("status", `1`);
            const resp = await instance({
                url: `/subject-topic-references${data ? '/' + data?.id : ''}`,
                method: data ? 'put' : 'post',
                data: dataReq
            })
            if (resp?.data?.status === 1) {
                asyncN("success", data ? "update" : "create", resp?.data?.message).then(() => {
                    setRefresh(!refresh);
                    closeModal(false);
                    form.resetFields()
                })
            } else {
                asyncN("error", data ? "update" : "create", resp?.data?.message)
            }
        } catch (error: any) {
            asyncN("error", data ? "update" : "create", error?.response ? error?.response?.data?.message : error?.message)
        }
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <Row gutter={24}>
                <Col span={24}>
                    <Form.Item name={'name'}>
                        <SunEditor setOptions={{
                            katex: "katex",
                            buttonList: [
                                [
                                    'undo',
                                    'redo'
                                ],
                                [
                                    'fullScreen',
                                    'preview'
                                ],
                                [
                                    'bold',
                                    'underline',
                                    'italic',
                                    'strike',
                                    'fontSize'
                                ],
                                [
                                    'subscript',
                                    'superscript'
                                ],
                                [
                                    'outdent',
                                    'indent',
                                    'list',
                                    'align'
                                ],
                                [
                                    'removeFormat',
                                    'image',
                                    'table'
                                ]
                            ]
                        }} setContents={data ? data?.name : ''} height={"125px"} placeholder="Muhokama uchun kazus yoki muammoli savol!" />
                    </Form.Item>
                </Col>
                <Col className="d-f justify-content-end" span={24}>
                    <Button onClick={() => {
                        closeModal(false)
                        form.resetFields()
                    }} danger type="primary">{t("Cancel")}</Button>
                    <Button className="mx-1" htmlType="reset">{t("Reset")}</Button>
                    <Button type="primary" htmlType="submit">{t("Save")}</Button>
                </Col>
            </Row>
        </Form>
    )
}

export default CaseOrQuestion;